module.exports = __webpack_public_path__ + "img/xiangmu7.4ed5e765.png";